import styled from 'styled-components'
import { media } from '../../cards'

export default styled.div`
     font-size: 26px;
     ${media.mobile`font-size: 18px`};
     text-align: center;

`
